const grid = document.querySelector('.masonry-grid');
const carousel = document.querySelector('.property-carousel');
const gallery = document.querySelector('.property-gallery');
const body = document.body;

let swiper;

// Check scroll pos
window.addEventListener('scroll', () => {
	document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}`);
});

// Open gallery
document.querySelectorAll('.js-toggle-property-gallery').forEach(function(btn) {
	btn.addEventListener('click', function() {
		toggleGallery();

		if (gallery.classList.contains('toggle')) {
			openModal();
		} else {
			closeModal();
			carousel.classList.add('hidden');
		}
	});
});

// Resize after each image loads
document.querySelectorAll('.masonry-item img').forEach(img => {
	if (img.complete) {
		resizeMasonryItem(img.parentElement);
	} else {
		img.addEventListener('load', () => resizeMasonryItem(img.parentElement));
	}
});

window.addEventListener('resize', resizeAllMasonryItems);

// Open the lightbox
if (grid) {
	grid.addEventListener('click', (e) => {
		if (e.target.tagName === 'IMG') {
			const index = Number(e.target.dataset.index);

			// Show the swiper wrapper
			carousel.classList.remove('hidden');

			// Lazy init Swiper if not already created
			if (!swiper) {
				swiper = new Swiper('.property-carousel', {
					initialSlide: index,
					lazy: true,
					loop: true,
					keyboard: {
						enabled: true,
					},
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
					pagination: {
						el: '.swiper-pagination',
					},
				});
			} else {
				swiper.slideTo(index);
			}
		}
	});
}

if (carousel) {
	carousel.addEventListener('click', (e) => {
		console.log(e.target);

		if (e.target.tagName === 'IMG') {
			carousel.classList.add('hidden');
		}
	});
}

// Functions
function resizeMasonryItem(item) {
	const grid = document.querySelector('.masonry-grid');
	const rowHeight = parseInt(getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
	const rowGap = parseInt(getComputedStyle(grid).getPropertyValue('gap'));
	const img = item.querySelector('img');

	if (!img || !img.complete) return;

	const imgHeight = img.offsetHeight;
	const rowSpan = Math.ceil((imgHeight + rowGap) / (rowHeight + rowGap));
	item.style.gridRowEnd = `span ${rowSpan}`;
}

function resizeAllMasonryItems() {
	document.querySelectorAll('.masonry-item').forEach(item => resizeMasonryItem(item));
}

function toggleGallery() {
	gallery.classList.toggle('toggle');
}

const openModal = () => {
	const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');

	body.style.position = 'fixed';
	body.style.top = `-${scrollY}px`;
	body.style.left = '0px';
	body.style.right = '0px';
};

const closeModal = () => {
	const scrollY = body.style.top;

	body.style.position = '';
	body.style.top = '';
	body.style.left = '';
	body.style.right = '';

	window.scrollTo(0, parseInt(scrollY || '0') * -1);
};
